import { ChildTask } from '@dynamika-shared/types/reader';
import { TASK_STATUSES } from './constants';

export function findAndTakeProperChildTask(sortedSubTasks: ChildTask[]) {
  let subTaskToLoad = [...sortedSubTasks].pop();
  const maybeStartedSubTask = sortedSubTasks.find(subTask =>
    [TASK_STATUSES.IN_PROGRESS, TASK_STATUSES.READING_PENDING].includes(
      subTask.status
    )
  );

  if (!maybeStartedSubTask) {
    for (const subTask of sortedSubTasks) {
      if (subTask.status === TASK_STATUSES.READING_PENDING) {
        subTaskToLoad = subTask;
        break;
      }
    }
  } else {
    subTaskToLoad = maybeStartedSubTask;
  }

  return subTaskToLoad;
}
